module.exports = __webpack_public_path__ + "static/img/2.d1a6d91.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/management/2.png
// module id = 10TI
// module chunks = 7